import React, { useCallback } from 'react';

import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { ReactComponent as OpenSeaIcon } from '@pkg/assets/icons/v2/opensea.svg';
import { ButtonDeprecated, MintTile } from '@pkg/components';
import { useAppDispatch, useAppSelector } from '@pkg/hooks';

import { type ArtifactType } from '@app/client/common/structs/nft/artifacts';
import { PathParams } from '@app/routes/types';
import {
    setArtifactMintPanelOpen,
    setArtifactMintPanelStep,
    setSelectedArtifactMintDisplay,
} from '@app/store/actions/artifacts';
import { artifactUrlToKeyMap } from '@app/store/types/artifacts';

import { Typography } from '../../../DesignSystem';
import '../ArtifactMintPanel.scss';

export const ArtifactMintComplete = () => {
    const { t } = useTranslation(['artifacts', 'dashboard']);
    const { [PathParams.ArtifactType]: urlArtifactType } = useParams();

    const dispatch = useAppDispatch();
    const { selectedArtifact } = useAppSelector((state) => state.artifacts);
    const { openSeaUrl } = useAppSelector((state) => state.nft);

    const artifactType = artifactUrlToKeyMap.get(urlArtifactType as ArtifactType) || artifactUrlToKeyMap.values()[0];
    const artifactId = selectedArtifact?.artifactId;

    const onClickOpenSea = useCallback(() => {
        window.open(openSeaUrl || '', '_blank');
        dispatch(setArtifactMintPanelOpen(false));
        dispatch(setArtifactMintPanelStep(null));
        dispatch(setSelectedArtifactMintDisplay(null));
    }, [dispatch, openSeaUrl]);

    return (
        <div className="yat-artifact-sidebar__step">
            <div className="yat-artifact-sidebar__content">
                <Typography type="headline" size={40} classes={['yat-artifact-sidebar__title']}>
                    {t('mint_artifact_complete_title')}
                </Typography>
                <Typography type="paragraph" size={16} classes={['yat-artifact-sidebar__text']}>
                    <span>{t('mint_artifact_complete_copy')}</span>
                </Typography>
                <div className={`yat-artifact-sidebar__preview`} onClick={onClickOpenSea}>
                    <MintTile artifactId={artifactId} artifactType={artifactType} hideButton />
                </div>

                {openSeaUrl && (
                    <ButtonDeprecated
                        color="tertiary"
                        icon={<OpenSeaIcon />}
                        onClick={onClickOpenSea}
                        size={'large'}
                        classes={['yat-artifact-sidebar__cta']}
                    >
                        {t('dashboard:view_on_opensea')}
                    </ButtonDeprecated>
                )}
            </div>
        </div>
    );
};
